export default "__VITE_ASSET__a0c8ed32__"